import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import SuccessIcon from '@material-ui/icons/Done';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { Text } from '../extensions/LangaugeContainer';

const styles = {
    paperinput:{
        textAlign:'left',
        width:'60%',
        marginLeft:'20%',
        marginRight:'20%',
        marginTop:"20px"
    },
    paperbutton: {
        width:'40%',
        marginLeft:'30%',
        marginRight:'30%',
        textTransform: 'none',
        marginTop:"10px"
    },

    paper:{
      marginTop: "20%",
      marginLeft: "15%",
      marginRight: "15%",
      marginBottom: "10px",
      paddingBottom: "40px",
      boxShadow: "1px 1px 1px 1px #AAA",
      height: "40%"
    }
}

class ManualCode extends Component {
    state = {
        code : ""
    }

    handleChange = (e) => {
        this.setState({ code: e.target.value})
    }

    reportState = () => {
        console.log("state:", this.state.code);
    }

    render() {
        return (
            <div >
                <Paper style={styles.paper} elevation={2}>
                    <TextField type='text' style={styles.paperinput}
                       id="name"
                       label={<Text tid="bockCode"/>}
                       value={this.state.code}
                       onChange={this.handleChange}
                    />
                    <Button
                      style={styles.paperbutton}
                      variant="outlined"
                      onClick={this.reportState}
                    >
                        <Text tid="finish"/>
                      <SuccessIcon />
                    </Button>
                </Paper>
            </div>
        );
    }
};

const mapStateToProps = state => ({
    application: state.app
});

export default withRouter(
    connect(
        mapStateToProps,
        {}
    )(ManualCode)
);